import { Stack } from '@mui/material';
import { MessageBox } from 'components/MessageBox';
import React, { useMemo } from 'react';
import { useStoreState } from 'state/hooks/store.state.hook';

export interface IMissingOffersBlockProps {
  hasNoOffers: boolean;
}

export const MissingOffersBlock: React.FC<IMissingOffersBlockProps> = ({
  hasNoOffers,
}) => {
  const { storeTheme, translations } = useStoreState();
  const {
    noOffersTitleText = translations!.noOffers,
    noOffersMessageText = translations!.noSpecialOffers,
    bundleBorderColor,
  } = useMemo(() => storeTheme!.storeScreen, [storeTheme!.storeScreen]);

  if (!hasNoOffers) return <></>;

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      width="100%"
      className="no_offers_box"
      padding={'2vh'}
    >
      <MessageBox
        title={noOffersTitleText}
        text={noOffersMessageText}
        fontFamily={storeTheme!.general.font}
        borderColor={bundleBorderColor.colorOne}
      />
    </Stack>
  );
};
